import * as React from 'react';
import { StyleSheet, Image } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import { View } from '../components/themed-view';

import splash from '../assets/images/splash.png';
import Book from '../components/book';
import Filter from '../constants/filter';
import { ExplorerParamList } from '../types';
import { options } from '../components/reading';
import useTranslation from '../hooks/translation';

const ExplorerStack = createStackNavigator<ExplorerParamList>();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function ExplorerNavigator() {
  useTranslation();
  return (
    <ExplorerStack.Navigator>
      <ExplorerStack.Screen
        name="Explorer"
        component={ExplorerScreen}
        options={{ headerShown: false }}
      />
      <ExplorerStack.Screen
        name="Exploring"
        component={ExplorerScreen}
        options={options}
        listeners={{
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          state: (e) => {
            // Oracle reading screen received eat bottom-tab-navigator from OracleScreen
          }
        }}
      />
    </ExplorerStack.Navigator>
  );
}

function ExplorerScreen() {
  const navigation = useNavigation();
  const route = useRoute();
  const params = route.params as ExplorerParamList;
  const reading = (params && params.reading) || undefined;

  const onFilter = (filter?: Filter) => {
    navigation.navigate('Root', { filter });
  };

  return (
    <View style={styles.container}>
      <Image source={splash} style={styles.bgImage} />
      <Book onFilter={onFilter} reading={reading} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch'
  },
  bgImage: {
    flex: 1,
    position: 'absolute',
    height: '100%',
    width: '100%',
    resizeMode: 'cover'
  },
  link: {
    marginTop: 15,
    paddingVertical: 15
  },
  linkText: {
    fontSize: 14,
    color: '#2e78b7'
  }
});
